<label class="nhsuk-label" [for]="'combobox-' + getSafeId(label)">{{ label }}</label>
<div class="combobox combobox-list">
  <div class="group">
    <input
      #inputElement
      [id]="'combobox-' + getSafeId(label)"
      class="cb_edit"
      type="text"
      role="combobox"
      aria-autocomplete="list"
      placeholder="Start typing to search..."
      [attr.aria-expanded]="isDropdownOpen"
      [attr.aria-controls]="'combobox-' + getSafeId(label) + '-listBox'"
      (input)="onInputChange($event)"
      (keydown)="onKeyDown($event)"
      [value]="searchText"
    />

    <button
      [id]="'combobox-' + getSafeId(label) + '-button'"
      tabindex="0"
      [attr.aria-label]="label + ' dropdown'"
      [attr.aria-expanded]="isDropdownOpen"
      [attr.aria-controls]="'combobox-' + getSafeId(label) + '-listBox'"
      (click)="toggleDropdown($event)"
      (keydown)="onButtonKeyDown($event)"
    >
      <svg width="18" height="16" aria-hidden="true" focusable="false" style="forced-color-adjust: auto">
        <polygon class="arrow" stroke-width="0" fill-opacity="0.75" fill="black" points="3,6 15,6 9,14"></polygon>
      </svg>
    </button>
  </div>

  @if (isDropdownOpen) {
    <ul [id]="'combobox-' + getSafeId(label) + '-listBox'" role="listbox" [attr.aria-label]="label">
      @for (option of filteredOptions; track $index) {
        <li
          [id]="getOptionId($index)"
          role="option"
          [attr.aria-selected]="$index === currentFocusIndex"
          [class.focused]="$index === currentFocusIndex"
          [value]="option.value"
          [innerHTML]="option.label | highlightSearch: searchText"
          [tabindex]="0"
          (click)="optionClicked(option, $index)"
          (keydown)="onOptionKeyDown($event, option, $index)"
        ></li>
      }
    </ul>
  }
</div>
